import { useQuery, useQueryClient } from 'react-query';
import { getPageToken } from 'client/screens/EpisodeListScreen/hooks';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { FetchEpisodesParams } from 'client/modules/AnchorAPI/v3/episodes';
import { AnchorAPI } from 'client/modules/AnchorAPI';

export const FETCH_EPISODES = 'episodes';

function useFetchEpisodes({
  pageToken,
  limit,
  orderBy,
  filterBy,
}: Partial<FetchEpisodesParams>) {
  const {
    state: { webStationId },
  } = useCurrentUserCtx();

  const queryClient = useQueryClient();
  const parsedPageToken = getPageToken(pageToken!);

  const { data, status } = useQuery(
    [FETCH_EPISODES, webStationId, parsedPageToken],
    () => {
      return AnchorAPI.fetchEpisodes({
        webStationId: webStationId!,
        limit,
        orderBy,
        filterBy,
        pageToken: parsedPageToken,
      });
    },
    {
      enabled: !!webStationId,
      keepPreviousData: true,
      // keeping it fresh since there are
      // many places where episodes gets updated
      staleTime: 0,
    }
  );

  const invalidateEpisodesQuery = () => {
    queryClient.invalidateQueries([FETCH_EPISODES, webStationId]);
  };

  return { episodes: data, status, invalidateEpisodesQuery };
}

export { useFetchEpisodes };
